export function noop() { };
export type VoidFn = () => void;



// WEBPACK FOOTER //
// /dist/src/app/shared/noop.function.ts